import { EndPoints } from "../Constants/endpoints";
import { GetPersonalInfoResponse } from "../interface/GeneralResponse";
import useGetData from "./ReactQuery/useGetData";

export const useGetPersonalInfo = () => {
  const { data, isLoading } = useGetData<GetPersonalInfoResponse>(
    EndPoints.GetPersonalInfo,
  );

  return {
    isAllowed: data?.Data?.CanBook ?? false,
    isLoading,
    data,
  };
};
